import React from 'react'
import Contact from '../Contact'

function contactme() {
  return (
   <>
   <Contact/>
   </>
  )
}

export default contactme